const PluralizeRoomDetails = ({ room, totalPassengers, totalNights }) => {
  const pluralize = (count, singular, plural) =>
    count > 1 ? `${count} ${plural}` : `${count} ${singular}`;

  const roomsCount = room?.rooms?.length ?? 0;

  return [
    pluralize(roomsCount, 'Habitación', 'Habitaciones'),
    pluralize(totalPassengers, 'Huésped', 'Huéspedes'),
    pluralize(totalNights, 'Noche', 'Noches'),
  ].join(', ');
};

export default PluralizeRoomDetails;
